import {
  getLocalStorageItem,
  setLocalStorageItem,
  setSessionStorageItem,
} from "@ifx-react/ifx-react-core";

export const SESSION_TOKEN_KEY = "sessionToken";

export const SMART_ORDER_DASHBOARD_WORKSPACE = "SmartOrderDashboardWorkSpace";

export const resetUserSessionToken = (params = {}) => {
  setLocalStorageItem(SESSION_TOKEN_KEY, { token: Math.random(), ...params });
  setSessionStorageItem(SMART_ORDER_DASHBOARD_WORKSPACE, null);
};

export const getUserSessionToken = () => getLocalStorageItem(SESSION_TOKEN_KEY);
